import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import posthog from 'posthog-js';
import './fonts.css';
import './index.css';
import './components/CoverageProof.css';
import App from './App';
import { onConsentChange, startConsentSync } from './lib/consent';
import { initAnalytics, applyConsent } from './lib/analytics';
import reportWebVitals from './reportWebVitals';

// Analytics is consent-gated (contract §3). `posthog.init` is the call that
// writes the distinct-id cookie and starts autocapture, so the gate sits in
// front of init itself — initialising with capturing opted out still stores
// an opt-out flag client-side, which is not the same as storing nothing. The
// X pixel is behind the same gate. The whole lifecycle (first grant, re-grant
// in the same page view, withdrawal, cross-tab sync) lives in
// src/lib/analytics.js so it can be unit tested; see src/lib/consent.js for
// why the decision lives in an apex-domain cookie.
initAnalytics();

// In-page decisions (banner, Cookie settings) and decisions synced from other
// tabs or developers.coinversa.ai all arrive as the same event. Withdrawal
// takes effect in the same page view it is given.
onConsentChange((event) => {
  const detail = event && event.detail;
  applyConsent(detail ? detail.state : null, {
    surface: detail ? detail.surface : undefined,
    origin: detail && detail.origin === 'sync' ? 'sync' : 'local',
  });
});
startConsentSync();

// Kept for console debugging and any lazily loaded code that still looks for
// the global; application code imports src/lib/analytics.js instead.
if (typeof window !== 'undefined') window.posthog = posthog;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
